import React from 'react';
import { FaInstagram } from 'react-icons/fa6';

const instagramHighlights = [
  {
    id: 1,
    caption: 'Love letters written but never sent.',
    note: '#microfiction · #literaryfiction',
  },
  {
    id: 2,
    caption: 'Writing soundtracks for the ones who loved quietly.',
    note: '#nowplaying · #writingrituals',
  },
  {
    id: 3,
    caption: 'Line edits over candlelight and ink.',
    note: '#authorlife · #firstdraft',
  },
  {
    id: 4,
    caption: 'The Arid Lips featured on readers’ bedside tables.',
    note: '#bookstagram · #readerlove',
  },
];

const Instagram: React.FC = () => {
  return (
    <section id="instagram" className="section">
      <div className="wrapper">
        <div className="section__header">
          <span className="eyebrow">Behind the Pages</span>
          <h2 className="headline">Instagram Moments & Microfiction</h2>
          <p className="lead">
            Follow @aarjay__s for daily fragments: annotated lines, writing rituals, playlists, and
            the whispered confessions that never made it into the book.
          </p>
        </div>

        <div className="surface">
          <div className="stack">
            <div className="btn-row">
              <a
                href="https://www.instagram.com/aarjay__s/"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn--primary"
              >
                {React.createElement(FaInstagram as React.ComponentType)} Follow @aarjay__s
              </a>
              <span className="text-subtle">
                Stories · Reels · Writing prompts · Reader Q&amp;A
              </span>
            </div>

            <div className="instagram-grid">
              {instagramHighlights.map((post) => (
                <div key={post.id} className="instagram-item">
                  <p style={{ margin: 0, fontSize: '1.1rem' }}>{post.caption}</p>
                  <span className="text-subtle" style={{ fontSize: '0.8rem' }}>
                    {post.note}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Instagram;

